@let code = this.code();
@let backBtnParams = this.backBtnParams();
@let submitBtnParams = this.submitBtnParams();

<div class="flex flex-col flex-1 items-center justify-center gap-6 px-4 py-8 text-center">
  <img
    [src]="img()"
    alt="Иллюстрация ошибки"
    width="160"
    height="160"
    class="w-40 h-40 object-contain"
    [attr.data-test-id]="testId() + '--image'"
  />

  <h1 class="text-xl md:text-2xl font-semibold text-base-content">
    {{ title() }}
  </h1>

  <div class="flex flex-col gap-2 w-full max-w-md">
    <div class="flex flex-col gap-1 text-base text-base-content/70">
      @switch (code) {
        @case ('unauthorized') {
          <ng-container [ngTemplateOutlet]="errorUnauthorizedRef"></ng-container>
        }
        @case ('forbidden') {
          <ng-container [ngTemplateOutlet]="errorForbiddenRef"></ng-container>
        }
        @case ('notFound') {
          <ng-container [ngTemplateOutlet]="errorNotFoundRef"></ng-container>
        }
        @case ('internalServerError') {
          <ng-container [ngTemplateOutlet]="errorInternalServerErrorRef"></ng-container>
        }
        @case ('serviceUnavailable') {
          <ng-container [ngTemplateOutlet]="errorServiceUnavailableRef"></ng-container>
        }
        @case ('oldBrowser') {
          <ng-container [ngTemplateOutlet]="errorOldBrowserRef"></ng-container>
        }
      }
    </div>

    @if (codesWithAdditionalText.includes(code)) {
      <div class="text-base text-base-content/70">
        @if (['notFound', 'internalServerError'].includes(code)) {
          <ng-container [ngTemplateOutlet]="errorPrevPageRef"></ng-container>
        } @else {
          <ng-container [ngTemplateOutlet]="errorLoginPageRef"></ng-container>
        }
      </div>
    }
  </div>
</div>

<div class="flex flex-col md:flex-row flex-1 gap-4 md:gap-6 justify-end md:justify-center items-stretch md:items-center px-4 pb-8 pt-6">
  @if (backBtnParams; as params) {
    <app-button
      [text]="params.text"
      [icon]="params.icon"
      variant="outline"
      size="lg"
      [testId]="testId() + '--back'"
      (clicked)="handleBackBtn()"
    />
  }

  @if (submitBtnParams; as params) {
    @if (params.routerLink) {
      <app-button
        [text]="params.text"
        [icon]="params.icon"
        [routerLink]="params.routerLink"
        size="lg"
        [testId]="testId() + '--submit'"
      />
    } @else if (params.href) {
      <app-button
        [text]="params.text"
        [icon]="params.icon"
        [href]="params.href"
        size="lg"
        [testId]="testId() + '--submit'"
      />
    } @else {
      <app-button
        [text]="params.text"
        [icon]="params.icon"
        size="lg"
        [testId]="testId() + '--submit'"
        (clicked)="handleSubmitBtn()"
      />
    }
  }
</div>

<ng-template #errorUnauthorizedRef>
  <p class="font-medium text-error">Ошибка 401</p>
  <p>Похоже, вы не вошли в систему или ваша сессия истекла. Пожалуйста, авторизуйтесь.</p>
</ng-template>

<ng-template #errorForbiddenRef>
  <p class="font-medium text-error">Ошибка 403</p>
  <p>Возможно, у вас недостаточно прав или вы не авторизованы.</p>
</ng-template>

<ng-template #errorNotFoundRef>
  <p class="font-medium text-error">Ошибка 404</p>
  <p>Страницы, которую вы ищете, у нас нет или она была удалена. Проверьте правильность введённого адреса.</p>
</ng-template>

<ng-template #errorInternalServerErrorRef>
  <p class="font-medium text-error">Ошибка 500</p>
  <p>Мы позаботимся о том, чтобы страница снова была загружена.</p>
</ng-template>

<ng-template #errorServiceUnavailableRef>
  <p class="font-medium text-error">Ошибка 503</p>
  <p>Попробуйте перейти на страницу позже.</p>
</ng-template>

<ng-template #errorOldBrowserRef>
  <p>Текущая версия браузера не поддерживает новую версию приложения. Рекомендуем обновить браузер, установить новый или перейти на старую версию приложения.</p>
</ng-template>

<ng-template #errorPrevPageRef>
  <p>Вы можете перейти на <a routerLink="/" class="link link-accent">главную страницу</a>.</p>
</ng-template>

<ng-template #errorLoginPageRef>
  <p>Попробуйте <button type="button" class="link link-accent p-0 bg-transparent border-none cursor-pointer" (click)="login()">войти</button> в систему или вернуться на <a routerLink="/" class="link link-accent">главную страницу</a>.</p>
</ng-template>
